import kids from './kids.png'
import babyshop from './babyshop.png'
import coctails from './coctails.png'
import weather from './weather.png'
export const data = [
     {
        id:1,
        title:"Kids Exercises",
        description:"This application is designed to keep kids engaged, foster good habits, and enhance their self-confidence and physical health. The app encourages positive behavior, promotes physical activity, and supports the development of essential life skills, all while providing a fun and stimulating environment for children.",
        image:kids,
        stack:["Ruby on Rails","HTML/CSS", "Bootstrap", "PostgreSQL"],
        link:"https://kids-exercises.fly.dev/",
        githubLink:"https://github.com/AlinaSapronova/Kids_Exercises",
},

{
        id:2,
        title:"Baby Growing Shop",
        description:"The BabyGrowing Shop project unites a family of brands and businesses dedicated to empowering customers worldwide to express their unique styles through fashion and design. By promoting sustainability, this initiative allows individuals to make environmentally conscious choices while showcasing their personal creativity.",
        image:babyshop,
        stack:["React", "Redux","HTML/CSS"],
        link:"https://luxury-pony-c4a770.netlify.app/",
        githubLink:"https://github.com/AlinaSapronova/Shop",
},
{
    id:3,
    title:"Weather App",
    description:"This app is designed to provide users with accurate and timely weather information tailored to their location. Featuring real-time updates, detailed forecasts, and interactive maps, WeatherWise helps users stay prepared for any weather conditions. ",
    image:weather,
    stack:["JavaScript","HTML/CSS","Weather API"],
    link:"https://guileless-sunburst-f0b49d.netlify.app/",
    githubLink:"https://github.com/AlinaSapronova/WeatherApp-TechPrep",
},

{
    id:4,
    title:"Cocktails",
    description:"In this app you can find your favorite cocktails Whether you're a seasoned bartender or a home enthusiast,this app offers an extensive collection of recipes. Explore classic cocktails and customize your own drinks.  Cheers to endless possibilities and exquisite flavors at your fingertips!",
    image:coctails,
    stack:["React","HTML/CSS","Coctails API"],
    link:"https://spontaneous-crumble-14d19d.netlify.app/",
    githubLink:"https://github.com/AlinaSapronova/Coctails/tree/main/coctails-recipes",
}
]

